var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#009FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6531 17C10.3929 17 10.1458 16.8995 9.96373 16.7238L6.28289 13.1702C5.9057 12.8061 5.9057 12.2033 6.28289 11.8392C6.66008 11.4751 7.28439 11.4751 7.66158 11.8392L10.6531 14.7272L17.3384 8.27311C17.7156 7.90896 18.3399 7.90896 18.7171 8.27311C19.0943 8.63725 19.0943 9.23997 18.7171 9.60412L11.3424 16.7238C11.1603 16.8995 10.9132 17 10.6531 17Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlueCircle);
export default __webpack_public_path__ + "static/media/check-blue-circle.b7886117f5753bf0645dafb99dec0058.svg";
export { ForwardRef as ReactComponent };